module.exports = __webpack_public_path__ + "img/noimage_camera.7a045d3d.png";